import React from 'react';
import { TrendingUp, Shield, Zap, Users, DollarSign, Target, ArrowRight, Award, Briefcase, BarChart2 } from 'lucide-react';
export function Investors() {
  return <div className="min-h-screen w-full" data-id="element-404">
      {/* Hero Section */}
      <section className="pt-32 pb-20 relative overflow-hidden" data-id="element-405">
        {/* Decorative elements */}
        <div className="absolute -top-[20%] -left-[10%] w-[70%] h-[70%] rounded-full bg-[#BBDDFF]/10 blur-3xl" data-id="element-406"></div>
        <div className="absolute -bottom-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-[#C85A15]/5 blur-3xl" data-id="element-407"></div>
        <div className="container mx-auto px-6 relative z-10" data-id="element-408">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-409">
            <div className="inline-block mb-4 px-4 py-1 rounded-full bg-gradient-to-r from-[#BBDDFF]/10 to-[#C85A15]/10 backdrop-blur-sm border border-white/10" data-id="element-410">
              <span className="text-sm font-medium" data-id="element-411">Seeking Seed Funding</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-412">
              <span className="bg-gradient-to-r from-[#BBDDFF] via-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-413">
                The future of digital healthcare
              </span>
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300" data-id="element-414">
              JoinOmu is positioned to revolutionize healthcare delivery with
              our three sided technology platform, dedicated provider network,
              and scalable business model.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-415">
            <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-xl p-8 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-416">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center mb-6" data-id="element-417">
                <TrendingUp className="text-[#BBDDFF]" size={24} data-id="element-418" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-419">Seed to Profitibility</h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-420">
                Ready to execute a proven plan to grow service locations
                together with our provider network for a sustainable future.
              </p>
            </div>
            <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-xl p-8 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-421">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center mb-6" data-id="element-422">
                <Target className="text-[#C85A15]" size={24} data-id="element-423" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-424">Market Opportunity</h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-425">
                Addressing a combined $97B+ market in weight management and
                men's health.
              </p>
            </div>
            <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-xl p-8 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-426">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center mb-6" data-id="element-427">
                <Zap className="text-[#BBDDFF]" size={24} data-id="element-428" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-429">Expansion Ready</h3>
              <p className="text-gray-600 dark:text-gray-300" data-id="element-430">
                Platform architecture designed to rapidly deploy into additional
                treatment areas beyond current offerings and possibly secure a
                Series A to fuel growth.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Metrics Section */}
      <section className="hidden py-20 bg-gradient-to-b from-white to-[#f8faff] dark:from-[#111827] dark:to-[#0a0e17]" data-id="element-431">
        <div className="container mx-auto px-6" data-id="element-432">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-433">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-434">
              <span className="bg-gradient-to-r from-gray-900 to-gray-700 dark:from-white dark:to-gray-300 bg-clip-text text-transparent" data-id="element-435">
                Our Growth Metrics
              </span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300" data-id="element-436">
              JoinOmu has demonstrated consistent growth across all key
              performance indicators
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-437">
            <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-438">
              <h3 className="text-xl font-bold mb-6" data-id="element-439">Performance Metrics</h3>
              <div className="space-y-6" data-id="element-440">
                <div data-id="element-441">
                  <div className="flex justify-between mb-2" data-id="element-442">
                    <span className="font-medium" data-id="element-443">Patient Acquisition</span>
                    <span className="font-bold text-[#C85A15]" data-id="element-444">+187%</span>
                  </div>
                  <div className="w-full h-3 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden" data-id="element-445">
                    <div className="h-full bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-full" style={{
                    width: '87%'
                  }} data-id="element-446"></div>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mt-2" data-id="element-447">
                    Consistent month-over-month growth in new patient sign-ups
                  </p>
                </div>
                <div data-id="element-448">
                  <div className="flex justify-between mb-2" data-id="element-449">
                    <span className="font-medium" data-id="element-450">Provider Network</span>
                    <span className="font-bold text-[#C85A15]" data-id="element-451">+93%</span>
                  </div>
                  <div className="w-full h-3 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden" data-id="element-452">
                    <div className="h-full bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-full" style={{
                    width: '63%'
                  }} data-id="element-453"></div>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mt-2" data-id="element-454">
                    Expanding network of licensed healthcare providers across
                    all 50 states
                  </p>
                </div>
                <div data-id="element-455">
                  <div className="flex justify-between mb-2" data-id="element-456">
                    <span className="font-medium" data-id="element-457">Revenue Growth</span>
                    <span className="font-bold text-[#C85A15]" data-id="element-458">+215%</span>
                  </div>
                  <div className="w-full h-3 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden" data-id="element-459">
                    <div className="h-full bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-full" style={{
                    width: '95%'
                  }} data-id="element-460"></div>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mt-2" data-id="element-461">
                    Year-over-year revenue growth with improving margins
                  </p>
                </div>
                <div data-id="element-462">
                  <div className="flex justify-between mb-2" data-id="element-463">
                    <span className="font-medium" data-id="element-464">Patient Retention</span>
                    <span className="font-bold text-[#C85A15]" data-id="element-465">89%</span>
                  </div>
                  <div className="w-full h-3 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden" data-id="element-466">
                    <div className="h-full bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] rounded-full" style={{
                    width: '89%'
                  }} data-id="element-467"></div>
                  </div>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mt-2" data-id="element-468">
                    Industry-leading retention rates demonstrating high patient
                    satisfaction
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-469">
              <h3 className="text-xl font-bold mb-6" data-id="element-470">Market Opportunity</h3>
              <div className="grid grid-cols-2 gap-6" data-id="element-471">
                <div className="bg-gray-50 dark:bg-gray-700/30 p-6 rounded-xl" data-id="element-472">
                  <div className="text-3xl font-bold bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent mb-2" data-id="element-473">
                    $78B
                  </div>
                  <div className="font-medium mb-2" data-id="element-474">
                    Weight Management Market
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-300" data-id="element-475">
                    U.S. market size with 8.8% CAGR driven by GLP-1 medications
                    and digital health adoption
                  </div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700/30 p-6 rounded-xl" data-id="element-476">
                  <div className="text-3xl font-bold bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent mb-2" data-id="element-477">
                    $19B
                  </div>
                  <div className="font-medium mb-2" data-id="element-478">Men's Health Market</div>
                  <div className="text-sm text-gray-600 dark:text-gray-300" data-id="element-479">
                    Growing segment with increasing demand for telehealth
                    solutions for sensitive health issues
                  </div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700/30 p-6 rounded-xl" data-id="element-480">
                  <div className="text-3xl font-bold bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent mb-2" data-id="element-481">
                    8.8%
                  </div>
                  <div className="font-medium mb-2" data-id="element-482">Annual Market Growth</div>
                  <div className="text-sm text-gray-600 dark:text-gray-300" data-id="element-483">
                    Combined market CAGR outpacing traditional healthcare
                    segments
                  </div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-700/30 p-6 rounded-xl" data-id="element-484">
                  <div className="text-3xl font-bold bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent mb-2" data-id="element-485">
                    5+
                  </div>
                  <div className="font-medium mb-2" data-id="element-486">
                    Expansion Treatment Areas
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-300" data-id="element-487">
                    Near-term expansion opportunities identified in adjacent
                    treatment categories
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Investment Highlights */}
      <section className="py-20 relative overflow-hidden" data-id="element-488">
        <div className="container mx-auto px-6 relative z-10" data-id="element-489">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-490">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-491">
              <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-492">
                Investment Highlights
              </span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300" data-id="element-493">
              Why JoinOmu represents a compelling investment opportunity in
              digital healthcare
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-494">
            <div className="flex" data-id="element-495">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-496">
                <Users className="text-[#BBDDFF]" size={24} data-id="element-497" />
              </div>
              <div data-id="element-498">
                <h3 className="text-lg font-semibold mb-2" data-id="element-499">
                  Experienced Leadership Team
                </h3>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-500">
                  Leadership with digital health experience across multiple
                  companies and has helped build and scale a $100M+ ARR digital
                  health company previously, pre-Series A.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-501">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-502">
                <Shield className="text-[#C85A15]" size={24} data-id="element-503" />
              </div>
              <div data-id="element-504">
                <h3 className="text-lg font-semibold mb-2" data-id="element-505">
                  Proprietary Technology Platform
                </h3>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-506">
                  Our three sided HIPAA-compliant infrastructure includes
                  connected apps for patients, providers, and administrators
                  with data analytics capabilities that exceed industry
                  standards and can create significant barriers to competition
                  at scale.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-507">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-508">
                <DollarSign className="text-[#BBDDFF]" size={24} data-id="element-509" />
              </div>
              <div data-id="element-510">
                <h3 className="text-lg font-semibold mb-2" data-id="element-511">Business Model</h3>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-512">
                  Our subscription-based model delivers high-margin recurring
                  revenue. Patient acquisition cost declines while lifetime
                  value continues to increase as we expand service offerings.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-513">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-514">
                <BarChart2 className="text-[#C85A15]" size={24} data-id="element-515" />
              </div>
              <div data-id="element-516">
                <h3 className="text-lg font-semibold mb-2" data-id="element-517">Growth Strategy</h3>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-518">
                  Diversified customer acquisition approach built to grow with
                  our provider network. As providers are added to the network a
                  combination of outdoor, social, and video streaming
                  advertising is run in the states where they're licensed.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-519">
              <div className="w-12 h-12 rounded-full bg-[#BBDDFF]/20 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-520">
                <Award className="text-[#BBDDFF]" size={24} data-id="element-521" />
              </div>
              <div data-id="element-522">
                <h3 className="text-lg font-semibold mb-2" data-id="element-523">
                  Clinical Outcomes Focus
                </h3>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-524">
                  Our evidence-based approach prioritizes measurable patient
                  outcomes. Well positioned and aware of potential value-based
                  care partnerships with pharmasutical companies, EHR/EMR, and
                  Healthcare AI companies.
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-525">
              <div className="w-12 h-12 rounded-full bg-[#C85A15]/20 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-526">
                <Briefcase className="text-[#C85A15]" size={24} data-id="element-527" />
              </div>
              <div data-id="element-528">
                <h3 className="text-lg font-semibold mb-2" data-id="element-529">
                  Clear Exit Opportunities
                </h3>
                <p className="text-gray-600 dark:text-gray-300" data-id="element-530">
                  Potential exit paths include strategic acquisition by
                  healthcare systems, other digital health companies, and
                  pharmaceutical companies. Public market opportunities may also
                  exist.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section className="py-20 bg-gradient-to-b from-[#f8faff] to-white dark:from-[#0a0e17] dark:to-[#111827]" data-id="element-531">
        <div className="container mx-auto px-6" data-id="element-532">
          <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800/80 backdrop-blur-sm rounded-2xl p-10 shadow-xl border border-white/20 dark:border-gray-700/30" data-id="element-533">
            <div className="text-center mb-10" data-id="element-534">
              <h2 className="text-3xl font-bold mb-4" data-id="element-535">
                <span className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] bg-clip-text text-transparent" data-id="element-536">
                  Connect With Our Team
                </span>
              </h2>
              <p className="text-lg text-gray-600 dark:text-gray-300" data-id="element-537">
                Interested in learning more about investing in JoinOmu? Our team
                is available to discuss our product, growth strategy, and
                investment opportunities.
              </p>
            </div>
            <div className="text-center" data-id="element-538">
              <a href="mailto:ryan@joinomu.com" className="bg-gradient-to-r from-[#BBDDFF] to-[#C85A15] text-white font-medium py-3 px-8 rounded-full hover:shadow-lg transition-all inline-flex items-center justify-center group" data-id="element-539">
                Request Investor Information
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} data-id="element-540" />
              </a>
            </div>
          </div>
          {/* Sources Section */}
          <div className="max-w-4xl mx-auto mt-8 text-center" data-id="element-541">
            <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-542">
              Sources: Market data based on reports from Grand View Research,
              Statista, and Markets and Markets (2022-2023). The U.S. weight
              management market is valued at approximately $78 billion with
              projected 8.8% CAGR through 2030. The U.S. men's health market is
              valued at approximately $19 billion with projected 6.5% CAGR
              through 2030. Combined market opportunity of $97 billion.
            </p>
          </div>
        </div>
      </section>
    </div>;
}